// SEO configuration - site-wide defaults and structured data
// Update SITE_URL after connecting the custom domain (wholesome360.com)

export const SITE_URL = 'https://wholesome360.com';
export const SITE_NAME = 'Wholesome 360';
export const BUSINESS_NAME = 'Wholesome 360 Catering';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/images/spread.jpg`;
export const LOGO_URL = `${SITE_URL}/images/logo.png`;

// Target keywords woven throughout the site
export const TARGET_KEYWORDS = [
  'healthy catering Chicago',
  'office catering Chicago',
  'corporate catering Chicago',
  'healthy meal delivery Chicago',
  'Mediterranean catering Chicago',
  'lunch catering Chicago',
  'corporate lunch catering',
  'healthy office lunch',
  'meal prep Chicago',
  'healthy food catering',
  'Mediterranean diet benefits',
  'anti-inflammatory foods',
  'healthy office lunch ideas',
  'gluten-free catering Chicago',
  'best Mediterranean bowls Chicago',
  'custom grain bowls catering',
  'healthy salad wraps Chicago',
  'plant-based catering Chicago',
];

// LocalBusiness JSON-LD schema — appears on all pages
export const BUSINESS_JSONLD = {
  '@context': 'https://schema.org',
  '@type': ['Restaurant', 'FoodEstablishment', 'CateringService'],
  '@id': `${SITE_URL}#business`,
  name: 'Wholesome 360',
  alternateName: BUSINESS_NAME,
  description:
    'Healthy and plant-based catering in Chicago. The best Mediterranean bowls, custom grain bowls catering, healthy salad wraps and from-scratch trays for office catering, corporate lunch catering and private events.',
  url: SITE_URL,
  logo: LOGO_URL,
  image: [DEFAULT_OG_IMAGE, LOGO_URL],
  telephone: '+1-773-857-0230',
  email: 'info@wholesome360.com',
  priceRange: '$$',
  servesCuisine: ['Mediterranean', 'Healthy', 'Plant-Based', 'Vegetarian', 'Vegan Options', 'Gluten-Free'],
  keywords:
    'plant-based catering Chicago, best Mediterranean bowls Chicago, custom grain bowls catering, healthy salad wraps Chicago',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '324 N. Leavitt Street',
    addressLocality: 'Chicago',
    addressRegion: 'IL',
    postalCode: '60612',
    addressCountry: 'US',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 41.8875,
    longitude: -87.6819,
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      opens: '09:00',
      closes: '18:00',
    },
  ],
  areaServed: {
    '@type': 'GeoCircle',
    geoMidpoint: {
      '@type': 'GeoCoordinates',
      latitude: 41.8875,
      longitude: -87.6819,
    },
    geoRadius: '32000', // 20 miles in meters
  },
  paymentAccepted: ['Cash', 'Credit Card'],
  currenciesAccepted: 'USD',
  hasMenu: `${SITE_URL}/#menu`,
  sameAs: [
    'https://www.instagram.com/wholesome360eats',
    'https://www.facebook.com/Wholesome360catering',
  ],
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '5.0',
    reviewCount: 31,
    bestRating: '5',
    worstRating: '1',
  },
};

// Menu JSON-LD generator — pulls from MENU_ITEMS
export function buildMenuJsonLd(menuItems) {
  const bySection = {};
  menuItems.forEach((item) => {
    const cat = item.category;
    if (!bySection[cat]) bySection[cat] = [];
    bySection[cat].push({
      '@type': 'MenuItem',
      name: item.name,
      description: item.description,
      image: item.image && item.image.startsWith('/') ? `${SITE_URL}${item.image}` : item.image,
      offers: {
        '@type': 'Offer',
        price: item.price.toFixed(2),
        priceCurrency: 'USD',
      },
    });
  });
  const sectionLabels = {
    bowls: 'Bowls',
    salads: 'Salads',
    wraps: 'Wraps',
    desserts: 'Desserts',
    beverages: 'Beverages',
  };
  return {
    '@context': 'https://schema.org',
    '@type': 'Menu',
    name: 'Wholesome 360 Catering Menu',
    hasMenuSection: Object.entries(bySection).map(([cat, items]) => ({
      '@type': 'MenuSection',
      name: sectionLabels[cat] || cat,
      hasMenuItem: items,
    })),
  };
}

// FAQ JSON-LD generator
export function buildFaqJsonLd(faqs) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  };
}
